export const ContactSection = () => {
    return (
        <div class="Section ContactSection" id="contact">
            <h2 style={{marginTop: "20px", marginBottom: "15px"}}>Contact me ✍️</h2>
            <div class="ContactSectionColumns" style={{color: "white"}}>
                <div class="ContactSectionColumn">
                    <h3>MILLENIAL SOCIALS</h3>
                    <a href="https://www.boredpanda.com/blog/wp-content/uploads/2021/10/facebook-meta-new-name-change-memes-617ba483457a6-png__700.jpg">Facebook</a>
                    <a href="https://www.linkedin.com/in/marius-genton-879092249/">LinkedIn</a>
                    <a href="mailto:mariusgenton@gmail.com">E-mail</a>
                </div>
                <div class="ContactSectionColumn">
                    <h3>GEN-Z SOCIALS</h3>
                    <a href="https://www.instagram.com/marius_genton/">Instagram</a>
                    <a href="https://www.youtube.com/watch?v=xvFZjo5PgG0">TikTok</a>
                    <a href="https://www.youtube.com/watch?v=xvFZjo5PgG0">BeReal</a>
                </div>
                <div class="ContactSectionColumn">
                    <h3>NERD SOCIALS</h3>
                    <a href="https://github.com/MariusGen1">GitHub</a>
                    <a href="https://codeforces.com/profile/Marsolgen">CodeForces</a>
                    <a href="https://www.hackerrank.com/mariusgenton?hr_r=1">HackerRank</a>
                </div>
            </div>
            <h5 style={{paddingTop: "80px", textAlign: "center", opacity: 0.7}}>© 2022 Marius Genton</h5>
        </div>
    )
}